import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import api from "../services/api";
import toastError from "../errors/toastError";
import { i18n } from "../translate/i18n";

const useHolidays = () => {
  const [holidays, setHolidays] = useState([]);
  const [holidayMessage, setHolidayMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchHolidays = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/holidays");
      setHolidays(data.holidays);
      setHolidayMessage(data.holidayMessage || "");
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHolidays();
  }, [fetchHolidays]);

  const updateHoliday = async (holidayId, payload) => {
    try {
      const { data } = await api.put(`/holidays/${holidayId}`, payload);
      setHolidays((prev) =>
        prev.map((h) => (h.id === data.id ? data : h))
      );
    } catch (err) {
      toastError(err);
    }
  };

  const saveHolidayMessage = async (message) => {
    try {
      await api.put("/holidays/message", { holidayMessage: message });
      setHolidayMessage(message);
    } catch (err) {
      toastError(err);
    }
  };

  const createCustomHoliday = async (month, day, name) => {
    try {
      await api.post("/holidays/custom", { month, day, name });
      await fetchHolidays();
      toast.success(i18n.t("feriados.customAdded"));
    } catch (err) {
      toastError(err);
      throw err;
    }
  };

  return {
    holidays,
    holidayMessage,
    loading,
    updateHoliday,
    saveHolidayMessage,
    setHolidayMessage,
    createCustomHoliday,
    refetch: fetchHolidays,
  };
};

export default useHolidays;
